/** LK diagnostics API is primary; MIS vatech catalog patient_linked is fallback when LK call fails. */
export function isPatientDiagnosticsLinked(input: {
  diagnocat?: { linked?: boolean; status?: string } | null
  catalogPatientLinked?: boolean | null
}): boolean {
  if (Boolean(input.diagnocat?.linked) && input.diagnocat?.status === 'linked') {
    return true
  }
  return input.catalogPatientLinked === true
}
